import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component } from '@angular/core';
import { ApiCallsService } from '../../../shared/services/network/api-calls.service';
import { SafeHtmlPipe } from '../../../shared/validators/safe-html.pipe';
import { api } from '../../../utils/endpoints';
import { ICONS } from '../../../utils/svg-icons';

@Component({
  selector: 'app-faqs',
  imports: [CommonModule, SafeHtmlPipe],
  templateUrl: './faqs.component.html',
  styleUrl: './faqs.component.scss',
})
export class FaqsComponent {
  checkedElement = 1;
  FaqList: any = [];
   ICONS = ICONS;
  constructor(
    private _apiService: ApiCallsService,
    private cdr: ChangeDetectorRef,
  ) {
    this.getContent();
  }
  getContent() {
    this._apiService.get(api._pageById + 'faqs').subscribe({
      next: (res: any) => {
        this.FaqList = res.data.faqs;
        this.checkedElement = res.data.faqs.length > 0 ? res.data.faqs[0]?.id : 1;
      },
      error: (err: any) => {
        console.log('err', err.error?.message);
      },
    });
  }
  OpenFaq(id: any) {
    this.checkedElement = this.checkedElement === id ? 0 : id;
    this.cdr.detectChanges();
  }
}
